<template>
    <!-- 高端测试 -->
    <div>
        <contentIndex :initInfo="info"></contentIndex>
    </div>
</template>
<script>
import contentIndex from "./index.vue"
export default {
    components: {
        contentIndex
    },
    data() {
        return {
            info: {
                type: 3,
                testTypeList: [
                    { dictLabel: "全部", dictValue: '' },
                    { dictLabel: "球差TEM", dictValue: '球差TEM' },
                    { dictLabel: "同步辐射", dictValue: '同步辐射' },
                    { dictLabel: "CT测试", dictValue: 'CT测试' },
                    // { dictLabel: "穆斯堡尔谱", dictValue: '穆斯堡尔谱' },
                    // { dictLabel: "三维原子探针", dictValue: '三维原子探针' },
                    { dictLabel: "配方破解", dictValue: '配方破解' },
                    { dictLabel: "失效分析", dictValue: '失效分析' },
                    // { dictLabel: "正电子湮灭", dictValue: '正电子湮灭' }
                ],
            }
        }
    }
}
</script>